"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockLocation = void 0;
var StockLocation;
(function (StockLocation) {
    StockLocation["POSTOUT"] = "POSTOUT";
    StockLocation["WAREHOUSE"] = "WAREHOUSE";
    StockLocation["STORE"] = "STORE";
    StockLocation["SUPPLIER"] = "SUPPLIER";
    StockLocation["PREORDER"] = "PREORDER";
    StockLocation["INFOPOINT_FALLBACK"] = "INFOPOINT_FALLBACK";
})(StockLocation || (exports.StockLocation = StockLocation = {}));
//# sourceMappingURL=StockEnums.js.map